import { StyleSheet } from "react-native";
import { colorList } from 'utils/colors'
import { ThemedValues } from 'styles/themed'

export const AppStyles = StyleSheet.create({
	webBackground: {
		width: '100%',
		height: '100%',
		backgroundColor: colorList.GREY.light,
	},
	webContainer: {
		alignSelf: 'center',
		borderWidth: 1,
		borderColor: colorList.GREY.primary,
		borderRadius: ThemedValues.borderRadius,
		overflow: 'hidden',
		margin: 20
	},
	webContainerMaxWidth: {
		width: '90%',
		maxWidth: 1080
	},
	webContainerFullWidth: {
		width: '100%',
		maxWidth: '100%'
	}
});
